import tw from 'twin.macro';

export const Link = tw.a`absolute top-0 left-0 opacity-0 w-0 h-0 focus:opacity-100 focus:z-10 focus:w-auto focus:h-auto`;
